import React from "react";
import { Box } from "@mui/material";
import { useParams } from "react-router-dom";

import { PageLayout } from "../../layouts/PageLayout";
import { CardLayout, PageHeader } from "../../components/v3";
import { AddEditGovernmentInvoiceForm } from "../../components/invoices";

export const AddEditGovernmentInvoice = () => {
  const { id } = useParams();

  return (
    <PageLayout>
      <Box sx={{ position: "relative", zIndex: 1 }}>
        <PageHeader title={id ? "Edit Client Invoice" : "Add Client Invoice"} />
      </Box>

      <Box sx={{ mt: -9, zIndex: 2, position: "relative" }}>
        <CardLayout>
          <AddEditGovernmentInvoiceForm />
        </CardLayout>
      </Box>
    </PageLayout>
  );
};
